<template>
  <div :id="groupId + '-' + item.id" class="accordion-item" :class="{'is-active': item.active}">
    <dt class="accordion-item-title">
      <button @click="toggle" class="accordion-item-trigger">
        <h4 class="accordion-item-title-text">{{ item.title }}</h4>
        <span class="accordion-item-trigger-icon"></span>
      </button>
    </dt>
    <transition
      name="accordion-item"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition">
      <dd v-if="item.active" class="accordion-item-details">
        <div v-html="item.details" class="accordion-item-details-inner"></div>
      </dd>
    </transition>
  </div>
</template>

<script>

export default {
  props: ['item', 'multiple', 'groupId'],
  methods: {
    toggle(event) {
      if (this.multiple) this.item.active = !this.item.active
      else {
        this.$parent.$children.forEach((item, index) => {
          if (item.$el.id === event.currentTarget.parentElement.parentElement.id) item.item.active = !item.item.active
          else item.item.active = false
        })
      }
    },

    startTransition(el) {
      el.style.height = el.scrollHeight + 'px'
    },

    endTransition(el) {
      el.style.height = ''
    }
  }
}
</script>
<style lang="stylus" scoped>
$browser-context = 16
$size = 8px

em(pixels, context =$browser-context)
  return (pixels/context)em

.btn-action-delete
  color #CC4B37
  cursor pointer

.accordion
  padding 0

  &>div
    border-bottom 1px solid rgba(10, 10, 10, 0.1)

  div:last-child .accordion-item-details
    border-radius 5px

  dd
    margin-left 0

.accordion-item-trigger,
.accordion-item-details-inner
  padding 1.6rem 2.4rem

.accordion-item-details-inner
  overflow auto
  font-size 14px

.accordion-item-title
  position relative

  h4
    font-size 1.6rem
    font-weight 700
    margin-bottom 0
    margin-top 0
    padding-right 20px

.accordion-item-trigger
  width 100%
  text-align left
  background-color transparent
  border none

.accordion-item-trigger-icon
  display block
  position absolute
  top 0
  right 2.4rem
  bottom 0
  margin auto
  width $size
  height $size
  border-right 3px solid #018478
  border-bottom 3px solid #018478
  transform rotate(45deg)
  transition transform 0.2s ease

  .is-active &
    transform translateY($size / 4) rotate(225deg)

.accordion-item-details
  overflow hidden

.accordion-item-enter-active, .accordion-item-leave-active
  will-change height
  transition height 0.2s ease

.accordion-item-enter, .accordion-item-leave-to
  height 0 !important

.is-active .accordion-item-title
  background-color #EBEBEB

</style>
